import type { NextPage } from 'next'
import { ThankYouSurvey } from '@/client/modules/ThankYouSurvey'
import { ThankYouSurveyProps } from '@/client/modules/ThankYouSurvey/types'
import { getCMSContent } from '@/client/utils'

const ThankYouSurveyPage: NextPage<ThankYouSurveyProps> = (data) => <ThankYouSurvey {...data} />

export async function getStaticProps({ defaultLocale, locale }) {
  const data = await getCMSContent(defaultLocale, locale, 'SURVEY_THANK_YOU')

  if (!data?.content) return { revalidate: 60, notFound: true }

  return {
    revalidate: 10,
    props: { ...data }
  }
}

export default ThankYouSurveyPage
